import { Inventory } from "../Model/Inventory";
import { Player } from "../Model/Player";
export function playerFactory(name, preview, chatImage, sprite) {
    return new Player(name, preview, chatImage, sprite, new Inventory());
}
